import { render, staticRenderFns } from "./switchClient.vue?vue&type=template&id=378beb1e&scoped=true"
import script from "./switchClient.vue?vue&type=script&lang=js"
export * from "./switchClient.vue?vue&type=script&lang=js"
import style0 from "./switchClient.vue?vue&type=style&index=0&id=378beb1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378beb1e",
  null
  
)

export default component.exports